import { createFileRoute } from '@tanstack/react-router';
import { NotFoundPage } from '@/components/errors';

// Catch-all route - shows 404 for unknown routes
export const Route = createFileRoute('/$')({
  component: NotFoundPage,
});
